<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Proje"
    }
</script>

<style scoped>

</style>